<div class="body">

    <div class="headline">

        {{offer.offertitle? offer.offertitle: 'Angebot ohne Titel'}}

    </div>

    <div class="description" *ngIf="offer.offerdesc" [innerHtml]="offer.offerdesc"></div>

    <div class="sub-title" *ngFor="let subTitle of subTitles">

        {{subTitle}}

    </div>

</div>